import styled from 'styled-components';
import { SvgIcon } from '../../Icon';
import { getScrollBarStyles } from '../../../config/styles';
import { theme } from '../../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  max-height: 220px;
  overflow-y: auto;
  ${getScrollBarStyles(2)}
`;

export const Header = styled.div`
  display: flex;
  column-gap: 2px;
`;

export const Title = styled.div`
  flex: 1;
  padding-top: 4px;
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary900};
  word-break: break-word;
`;

export const Description = styled.div`
  line-height: 1.5;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  word-break: break-word;
  color: ${theme.colors.secondary800};
`;

export const DescriptionTerm = styled.div`
  color: ${theme.colors.secondary900};
`;

export const Icon = styled(SvgIcon)`
  color: ${theme.colors.mainBlue};
`;
